import React, { useState } from "react";

import Box from "@mui/material/Box";
import Accordion from "@mui/material/Accordion";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";

import { accordionData } from "shared/constants/faq";

const FAQ: React.FC = () => {
  const [expanded, setExpanded] = useState<number | false>(false);

  const handleChange =
    (panel: number) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  return (
    <Container sx={styles.faqBlock}>
      <Box sx={styles.topHeading}>
        <Typography variant="h2" sx={{ mb: 7.5 }}>
          Часті запитання
        </Typography>
        <Box>
          {accordionData.map((item, index) => (
            <Accordion
              key={index}
              elevation={0}
              expanded={expanded === index}
              onChange={handleChange(index)}
            >
              <AccordionSummary>
                <Typography variant="h3" sx={{ fontWeight: 400 }}>
                  {item.title}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  color="grey800"
                  sx={{ whiteSpace: "pre-line", fontWeight: 400 }}
                >
                  {item.text}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Box>
    </Container>
  );
};

const styles = {
  faqBlock: {
    textAlign: "center",
    width: { xs: "100%", md: "70%" },
    paddingTop: { xs: "56px", sm: "96px" },
    paddingBottom: { xs: "56px", sm: "96px" },
  },
  topHeading: {
    textAlign: "center",
    marginBottom: "60px",
  },
};

export default FAQ;
